import React from 'react';
import { PlusIcon, MinusIcon, AIcon } from "svg/icons";
import { useTranslate } from 'context/LanguageContext';
import { changeFontSize } from "extra/theme";


const font_switcher = [
	{ action: "less", title: "smaller_font_size", content: <MinusIcon/> },
	{ action: "normal", title: "normal_font_size", content: <AIcon/> },
	{ action: "more", title: "larger_font_size", content: <PlusIcon/> }
];


const FontSizeSwitcher = () => {

	const translate = useTranslate();

	return (
		<div className="font-size-switcher df-ac">
			{ font_switcher.map( item => (
				<a 
					href="#" 
					key={ item.action } 
					title={ translate( item.title )}
					className={`font-size-${ item.action }`}
					onClick={ e => { 
						e.preventDefault(); 
						changeFontSize( item.action )
					}}
				> 
					{ item.content } 
					<span className="d-none"> { item.title } </span> 
				</a>

			)) }
		</div>
	)
}

export default FontSizeSwitcher;